import { useDeviceDetection } from './useDeviceDetection';
import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState } from 'react';

/**
 * Hook para obtener información del dispositivo para autenticación OTP
 */
export const useDeviceInfo = () => {
  const deviceDetection = useDeviceDetection();
  const [deviceId, setDeviceId] = useState<string>('');
  const [deviceName, setDeviceName] = useState<string>('');

  useEffect(() => {
    // Obtener o generar ID de dispositivo
    const storedDeviceId = localStorage.getItem('deviceId');
    if (storedDeviceId) {
      setDeviceId(storedDeviceId);
    } else {
      // Generar un ID único para este dispositivo
      const newDeviceId = uuidv4();
      localStorage.setItem('deviceId', newDeviceId);
      setDeviceId(newDeviceId);
    }

    // Detectar nombre de dispositivo
    const userAgent = navigator.userAgent;
    let detectedDeviceName = 'Dispositivo desconocido';

    // Detectar sistema operativo
    if (/windows/i.test(userAgent)) {
      detectedDeviceName = 'Windows';
    } else if (/macintosh|mac os/i.test(userAgent)) {
      detectedDeviceName = 'MacOS';
    } else if (/android/i.test(userAgent)) {
      detectedDeviceName = 'Android';
    } else if (/iphone|ipad|ipod/i.test(userAgent)) {
      detectedDeviceName = 'iOS';
    } else if (/linux/i.test(userAgent)) {
      detectedDeviceName = 'Linux';
    }

    // Agregar tipo de dispositivo
    if (deviceDetection.isMobile) {
      detectedDeviceName += ' Móvil';
    } else if (deviceDetection.isTablet) {
      detectedDeviceName += ' Tablet';
    } else if (deviceDetection.isDesktop) {
      detectedDeviceName += ' Desktop';
    }

    // Establecer el nombre del dispositivo
    setDeviceName(`PayPlus POS - ${detectedDeviceName}`);
  }, [deviceDetection]);

  return {
    ...deviceDetection,
    deviceId,
    deviceName
  };
};
